// @ts-nocheck — TODO(flow-migration): fix types incrementally
import { GreatMemberViewContainer } from 'Views/great-members/GreatMembersView.container';
export default GreatMemberViewContainer;
